import React, { useEffect, useState } from 'react';
import { Container, Typography, Card, CardContent, Link, Box } from '@mui/material';
import bibtexParse from 'bibtex-parse-js';
import { formatAuthors } from '../utils';

function Journal() {
    const [papers, setPapers] = useState([]);
    const showMetrics = false; // メトリクスを表示させるかどうかのフラグ

    useEffect(() => {
        fetch(`${process.env.PUBLIC_URL}/journal-papers.bib`)
            .then((response) => response.text())
            .then((data) => {
                const parsed = bibtexParse.toJSON(data);
                setPapers(parsed);
            })
            .catch((error) => console.error('Error loading BibTeX file:', error));
    }, []);

    return (
        <Container>
            {papers.map((paper, index) => (
                <Card
                    key={index}
                    variant="outlined"
                    sx={{
                        marginBottom: '20px',
                        display: 'flex',
                        alignItems: 'flex-start',
                        padding: '10px',
                    }}
                >
                    {/* 左側の情報 */}
                    <CardContent sx={{ flex: 1 }}>
                        <Typography variant="body1" sx={{ fontWeight: 'bold', marginBottom: '5px' }}>
                            {paper.entryTags.title}
                        </Typography>
                        <Typography variant="body2" color="textSecondary" sx={{ marginBottom: '5px' }}>
                            {formatAuthors(paper.entryTags.author)}
                        </Typography>
                        <Typography variant="body2" color="textSecondary" sx={{ marginBottom: '5px' }}>
                            {paper.entryTags.journal}, Vol. {paper.entryTags.volume}, pp. {paper.entryTags.pages}, {paper.entryTags.year}
                        </Typography>
                        {paper.entryTags.doi && (
                            <Typography variant="body2" color="textSecondary" sx={{ marginBottom: '5px' }}>
                                DOI: <Link href={`https://doi.org/${paper.entryTags.doi}`} target="_blank" rel="noopener noreferrer">
                                    {paper.entryTags.doi}
                                </Link>
                            </Typography>
                        )}
                        {paper.entryTags.url && (
                            <Typography variant="body2">
                                <Link href={paper.entryTags.url} target="_blank" rel="noopener noreferrer">
                                    External Link
                                </Link>
                            </Typography>
                        )}
                    </CardContent>

                    {/* 右側のメトリクス（条件付き表示） */}
                    {showMetrics && paper.entryTags.scimagoId && (
                        <Box
                            sx={{
                                flexShrink: 0,
                                marginLeft: '10px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '120px',
                                height: '120px',
                                overflow: 'hidden',
                            }}
                        >
                            <Link
                                href={`https://www.scimagojr.com/journalsearch.php?q=${paper.entryTags.scimagoId}&tip=sid&exact=no`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img
                                    src={`https://www.scimagojr.com/journal_img.php?id=${paper.entryTags.scimagoId}`}
                                    alt={`SCImago Journal & Country Rank for ${paper.entryTags.journal}`}
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'contain',
                                    }}
                                />
                            </Link>
                        </Box>
                    )}
                </Card>
            ))}
        </Container>
    );
}

export default Journal;
